function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { createContext } from "react";
import cx from "classnames";
import { twMerge } from "../utils";
export var imageContextDefaultValue = {
    ImageComponent: function(_param) /*#__PURE__*/ {
        var _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, _objectFit = _param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit, _objectPosition = _param.objectPosition, objectPosition = _objectPosition === void 0 ? "center" : _objectPosition, blurDataURL = _param.blurDataURL, className = _param.className, props = _objectWithoutProperties(_param, [
            "alt",
            "objectFit",
            "objectPosition",
            "blurDataURL",
            "className"
        ]);
        return React.createElement("img", _extends({}, props, {
            className: twMerge(cx(objectFit === "cover" && "object-cover", objectFit === "contain" && "object-contain", objectFit === "fill" && "object-fill", className)),
            style: {
                objectPosition: objectPosition
            },
            alt: alt
        }));
    }
};
export var ImageContext = /*#__PURE__*/ createContext(imageContextDefaultValue);

//# sourceMappingURL=ImageContext.js.map